<template>
	<apexchart width="100%" height="100%" type="line" :options="chartOptions" :series="series" />
</template>

<script>
	export default {
		name: 'AppLineChart',
		props: {
			labels: {
				required: true,
				type: [Array],
			},
			series: {
				required: true,
				type: [Array],
			},
		},
		computed: {
			chartOptions() {
				return {
					stroke: {
						width: 3,
						curve: 'smooth',
					},
					xaxis: {
						categories: this.labels,
					},
				};
			},
		},
	};
</script>
